import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { GsapService } from '../../animations/gsap.service';
import { Seo } from '../../data/models/components/seo';

@Component({
  selector: 'placeme-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.scss'],
})
export class JumbotronComponent {
  @Input() category: string;
  @Input() seo: Seo;

  @ViewChild('headerRef', { static: false }) set headerRef(headerRef: ElementRef<HTMLElement>) {
    const image = headerRef?.nativeElement.querySelector('.image');
    const content = headerRef?.nativeElement.querySelector('.content');

    if (image && content) {
      this.gsapService
        .timeline()
        .fromTo(
          content,
          {
            scale: 0.95,
            opacity: 0,
          },
          {
            scale: 1,
            opacity: 1,
            duration: 0.4,
            ease: this.gsapService.easeInOut(),
          }
        )
        .fromTo(
          image,
          { scale: 1.4, yPercent: 0 },
          {
            scrollTrigger: {
              trigger: image,
              start: 'top top',
              scrub: 0.1,
            },
            scale: 1.4,
            yPercent: -10,
          },
          0
        );
    }
  }

  constructor(private gsapService: GsapService) {}
}
